export default "__VITE_ASSET__DMvvzCZC__"